import React from "react";
import {
  SEO,
  PageLayout,
  HeroElement,
  Content,
  ImageCollection,
  Special,
  Reviews,
  CustomerReviewModal,
  Contact,
} from "@bluefin/components";
import { Grid, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getPageHeroImage, getPageGalleryImages } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      allFishermanBusinessMenuItem,
      allFishermanBusinessMenuCategory,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getPageHeroImage({
            options: fishermanBusinessWebsitePage.components,
          })}
        />
        <PageLayout
          hero={
            <HeroElement
              header={fishermanBusiness.name}
              tagline={""}
              images={getPageHeroImage({
                options: fishermanBusinessWebsitePage.components,
              })}
              ctas={[fishermanBusiness.ctas.orderOnline]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={500}
              gutter={false}
            />
          }
          subfooter={false}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <Content>
                <Content.Markup>
                  {fishermanBusiness.aboutMarkdown}
                </Content.Markup>
              </Content>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16}>
              <ImageCollection
                images={getPageGalleryImages({
                  options: fishermanBusinessWebsitePage.components,
                })}
                as={"gallery"}
                centered={true}
                cutUnevenRows={false}
                disable={"none"}
                header={"Photos"}
                numberOfRowDisplayItems={3}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <Special
                header={<h1>Specials</h1>}
                type={"default"}
                items={allFishermanBusinessMenuItem.nodes}
                categories={allFishermanBusinessMenuCategory.nodes}
              />
            </Grid.Column>
          </Grid>
          <Grid stackable={true} className={"component-section-container"}>
            <Grid.Column width={16}>
              <Reviews
                reviews={fishermanBusiness.reviews}
                as={"horizontalItem"}
                buttonBasic={false}
                buttonSize={"medium"}
                centerHeader={true}
                cardInlinePhoto={"left"}
                header={"Reviews"}
                imageCircular={false}
                imageSize={"small"}
                itemButtonFloat={false}
                itemCenterContent={false}
                itemsDivided={false}
                itemsPerRow={3}
                linkAs={"none"}
                onlyEvenRows={true}
                showImage={true}
                verticalItemAlign={"left"}
              />
              <CustomerReviewModal
                businessId={fishermanBusiness._id}
                locations={allFishermanBusinessLocation.nodes}
                businessType={"restaurant"}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            textAlign={"center"}
          >
            <Grid.Column width={16}>
              <div className={"contact-container"}>
                <Button
                  color={"red"}
                  as={"a"}
                  href={
                    "https://direct.chownow.com/order/29512/locations/43629"
                  }
                  target={"_blank"}
                  content={"Order Online"}
                />
                <Contact
                  businessName={fishermanBusiness.name}
                  phoneNumber={fishermanBusiness.primaryLocation.phoneNumber}
                  email={fishermanBusiness.primaryLocation.email}
                  hours={fishermanBusiness.primaryLocation.hours}
                  address={{
                    street: fishermanBusiness.primaryLocation.street,
                    city: fishermanBusiness.primaryLocation.city,
                    state: fishermanBusiness.primaryLocation.state,
                    zip: fishermanBusiness.primaryLocation.zipCode,
                  }}
                  as={"text"}
                  buttonColor={"secondary"}
                  header={"Contact"}
                  image={""}
                  showMap={true}
                />
              </div>
              <div className={"contact-container"}>
                <Button
                  color={"red"}
                  as={"a"}
                  href={
                    "https://direct.chownow.com/order/29512/locations/43631"
                  }
                  target={"_blank"}
                  content={"Order Online"}
                />
                <Contact
                  businessName={fishermanBusiness.name}
                  phoneNumber={fishermanBusiness.locations[1].phoneNumber}
                  email={fishermanBusiness.locations[1].email}
                  hours={fishermanBusiness.locations[1].hours}
                  address={{
                    street: fishermanBusiness.locations[1].street,
                    city: fishermanBusiness.locations[1].city,
                    state: fishermanBusiness.locations[1].state,
                    zip: fishermanBusiness.locations[1].zipCode,
                  }}
                  as={"text"}
                  buttonColor={"secondary"}
                  header={"Contact"}
                  image={""}
                  showMap={true}
                />
              </div>
              <div className={"contact-container"}>
                <Button
                  color={"red"}
                  as={"a"}
                  href={
                    "https://direct.chownow.com/order/29512/locations/43630"
                  }
                  target={"_blank"}
                  content={"Order Online"}
                />
                <Contact
                  businessName={fishermanBusiness.name}
                  phoneNumber={fishermanBusiness.locations[2].phoneNumber}
                  email={fishermanBusiness.locations[2].email}
                  hours={fishermanBusiness.locations[2].hours}
                  address={{
                    street: fishermanBusiness.locations[2].street,
                    city: fishermanBusiness.locations[2].city,
                    state: fishermanBusiness.locations[2].state,
                    zip: fishermanBusiness.locations[2].zipCode,
                  }}
                  as={"text"}
                  buttonColor={"secondary"}
                  header={"Contact"}
                  image={""}
                  showMap={true}
                />
              </div>
              <div className={"contact-container"}>
                <Button
                  color={"red"}
                  as={"a"}
                  href={
                    "https://direct.chownow.com/order/29512/locations/43632"
                  }
                  target={"_blank"}
                  content={"Order Online"}
                />
                <Contact
                  businessName={fishermanBusiness.name}
                  phoneNumber={fishermanBusiness.locations[3].phoneNumber}
                  email={fishermanBusiness.locations[3].email}
                  hours={fishermanBusiness.locations[3].hours}
                  address={{
                    street: fishermanBusiness.locations[3].street,
                    city: fishermanBusiness.locations[3].city,
                    state: fishermanBusiness.locations[3].state,
                    zip: fishermanBusiness.locations[3].zipCode,
                  }}
                  as={"text"}
                  buttonColor={"secondary"}
                  header={"Contact"}
                  image={""}
                  showMap={true}
                />
              </div>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      ctas {
        orderOnline {
          text
          link
          internal
          className
        }
      }
      aboutMarkdown
      reviews {
        author
        text
        link
      }
      _id
      primaryLocation {
        phoneNumber
        email
        hours {
          open
          close
          label
          day
        }
        street
        city
        state
        zipCode
      }
      locations {
        phoneNumber
        email
        hours {
          open
          close
          label
          day
        }
        street
        city
        state
        zipCode
      }
    }
    fishermanBusinessWebsitePage(title: { eq: "Home" }) {
      title
      components {
        fastId
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
    allFishermanBusinessMenuItem(filter: { isSpecial: { eq: true } }) {
      nodes {
        description
        _id
        name
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        variations {
          _id
          name
          order
          price
        }
      }
    }
    allFishermanBusinessMenuCategory {
      nodes {
        name
        _id
        items
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        name
        phoneNumber
        primaryLocation
      }
    }
  }
`;
